import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const NotFoundPage = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6 pt-32">
      <div className="max-w-2xl mx-auto text-center space-y-12">
        {/* 404 Illustration */}
        <div className="relative">
          <h1 className="text-[180px] lg:text-[240px] font-black text-slate-100 leading-none tracking-tighter">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 bg-subidha-blue/5 rounded-full flex items-center justify-center animate-pulse">
              <Search className="w-16 h-16 text-subidha-blue/30" />
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-6">
          <div className="space-y-4">
            <h2 className="text-4xl lg:text-5xl font-serif-brand font-black text-slate-900">
              {t("notFound.title")}
            </h2>
            <p className="text-lg text-slate-500 font-medium max-w-md mx-auto leading-relaxed">
              {t("notFound.subtitle")}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Link
              to="/"
              className="w-full sm:w-auto bg-subidha-blue hover:bg-slate-900 text-white px-10 py-5 rounded-full font-black flex items-center justify-center space-x-3 transition-all shadow-xl shadow-blue-900/10 active:scale-95"
            >
              <Home className="w-5 h-5" />
              <span>{t("notFound.goHome")}</span>
            </Link>
            <button
              onClick={() => window.history.back()}
              className="w-full sm:w-auto px-10 py-5 text-subidha-blue font-black hover:text-accent-green transition-colors flex items-center justify-center space-x-2"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>{t("common.back")}</span>
            </button>
          </div>
        </div>

        {/* Popular Links */}
        <div className="pt-12 border-t border-slate-200">
          <p className="text-xs font-black text-slate-400 uppercase tracking-widest mb-6">
            Quick Links
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6">
            <Link
              to="/"
              className="text-sm font-bold text-slate-600 hover:text-subidha-blue transition-colors"
            >
              Home
            </Link>
            <Link
              to="/#about-us"
              className="text-sm font-bold text-slate-600 hover:text-subidha-blue transition-colors"
            >
              About Us
            </Link>
            <Link
              to="/#register"
              className="text-sm font-bold text-slate-600 hover:text-subidha-blue transition-colors"
            >
              Register
            </Link>
            <Link
              to="/#contact-us"
              className="text-sm font-bold text-slate-600 hover:text-subidha-blue transition-colors"
            >
              Contact
            </Link>
            <Link
              to="/login"
              className="text-sm font-bold text-slate-600 hover:text-subidha-blue transition-colors"
            >
              Admin Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
